<template>
  <td class="tableUnit">
    <input
      :class="{ selectedUnit: selected, editable: !editable }"
      ref="input"
      :readonly="type == 'text' || !editable"
      :disabled="type"
      @blur="onBlur"
      @keydown="onKeyDown"
      v-model="inputValue"
      @input="onInput"
      @focus="onFocus"
    />
    <a
      @mousedown="onCmbClick"
      v-if="type == 'cmb' && editable"
      class="dropdownIcon"
      ><i class="el-icon-arrow-down"></i
    ></a>
    <td-ex-dropdown
      class="select-list"
      :display="display"
      :show.sync="isShowList"
      @enterSelect="enterSelect"
      :selectList="searchList"
      :selected-index.sync="selectedListIndex"
      @update:selectedIndex="onKeyDown({ keyCode: 13, target: $refs.input })"
    />
    <el-date-picker
      v-if="type == 'date' && editable"
      v-model="dateTime"
      @change="changeTime"
      type="date"
      value-format="yyyy-MM-dd"
      :picker-options="pickerTimeOptions"
    >
    </el-date-picker>
  </td>
</template>

<script>
import TdExDropdown from "./TdExDropdown";
import "./scrollIntoViewIfNeeded.js";
function depCopy(target, source) {
  // 1.通过遍历拿到source中所有的属性
  for(let key in source){
    // 2.取出当前遍历到的属性对应的取值
    let sourceValue = source[key];
    // 3.判断当前的取值是否是引用数据类型
    if(sourceValue instanceof Object){
      let subTarget = new sourceValue.constructor;
      target[key] = subTarget;
      depCopy(subTarget, sourceValue);
    }else{
      target[key] = sourceValue;
    }
  }
}
export default {
  props: {
    bindValue: {
      required: true,
    },
    display: String,
    take: String,
    type: {
      type: String,
      default: "text",
    },
    list: {
      type: Array,
      default: () => [],
    },
    number: Boolean,
    editable: {
      default: true,
      type: Boolean,
    },
    decimalLength: Number,
    positive: Boolean,
  },
  mounted() {
    if (this.type == "cmb") {
      let item = this.searchList.find((f) => {
        let selected = this.take ? f[this.take] : f;
        return this.bindValue == selected;
      });
      if (item) {
        this.inputValue = this.display ? item[this.display] : item;
      }
    } else if (this.type == "date") {
      if (this.bindValue == "") {
        this.dateTime = "";
      } else {
        this.dateTime = this.bindValue;
      }
    } else {
      if (this.number && this.bindValue == 0) {
        this.inputValue = 0;
      } else {
        this.inputValue = this.bindValue;
      }
    }
  },
  model: {
    prop: "bindValue",
    event: "changeModel",
  },
  data() {
    return {
      dateTime: null, //日期
      inputValue: "",
      isShowList: false, // 是否显示当前下拉列表
      showListTimeout: null,
      selectedListIndex: 0, // 下拉列表index
      selected: false, // 焦点是否选中
      // 限制日期
      pickerTimeOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now() - 8.64e6;
        // }
      },
      // 判断是否点击了展开下拉菜单箭头, 因为输入框失去焦点需要关闭下拉菜单, 点击箭头又会打开下拉菜单, 会冲突造成下拉一闪不见的bug
      isCmbClick: false
    };
  },
  computed: {
    searchList() {
      if (this.type != "cmb") return;
      // 新逻辑 start
      const res = this.list.filter((f) => {
        let value = this.display ? f[this.display] : f;
        if (this.list.length >= 5) {
          return value.indexOf(this.inputValue) > -1;
        } else {
          return value;
        }
        // .indexOf(this.inputValue) > -1
      });
      console.log(res, '过滤出来啥');
      if(res.length === this.list.length) return this.list
      const copyList = []
      depCopy(copyList, this.list)
      res.forEach( item => {
        const index = copyList.findIndex( item2 => item.name === item2.name)
        copyList.splice(index, 1);
        copyList.unshift(item)
      })
      return copyList
      // 新逻辑 end
      // 旧逻辑start
      // return this.list.filter((f) => {
      //   let value = this.display ? f[this.display] : f;
      //   return value.indexOf(this.inputValue) > -1;
      // });
      // 旧逻辑end
    },
  },
  components: {
    TdExDropdown,
  },
  methods: {
    onFocus(e) {
      this.isCmbClick = false;
      this.$nextTick(() => e.target.select());
      this.selected = true;
      if (this.showListTimeout) clearTimeout(this.showListTimeout);
    },
    showList(show) {
      if (show) {
        if (this.showListTimeout) clearTimeout(this.showListTimeout);
        this.isShowList = true;
      } else {
        this.showListTimeout = setTimeout(() => {
          this.isShowList = false;
        }, 300);
      }
    },
    onInput(e) {
      this.$nextTick(() => this.$emit("input", e));
      if (this.type == "cmb") {
        this.$nextTick(() => {
          if (this.searchList.length == 0) {
            this.isShowList = false;
            this.$emit("changeModel", null);
          } else {
            this.isShowList = true;
          }
        });
      } else if (this.type == "number") {
        let value = this.inputValue;
        let isInt = /^[-]?[0-9]*$/.test(value);
        let isInputDecimal = /^[-]?[0-9]+\.[0-9]{0,10}$/.test(value);

        if (value == "-") {
          value = 0;
        } else if (isInt) {
          value = Number(this.inputValue);
        } else if (isInputDecimal) {
          if (value[value.length - 1] == ".") {
            value = value.replace(/\./, "");
            value = Number(value);
          } else if (this.decimalLength) {
            let subLength =
              this.inputValue.indexOf(".") + this.decimalLength + 1;
            if (subLength < this.inputValue.length) {
              this.inputValue = this.inputValue.substring(0, subLength);
            }
            value = Number(this.inputValue);
          }
        } else {
          value = 0;
          this.inputValue = "";
        }
        this.$emit("changeModel", value);
      } else {
        this.$emit("changeModel", this.inputValue);
      }
    },
    onBlur() {
      this.selected = false;
      if (this.type == "cmb") {
        this.showListTimeout = setTimeout(() => {
          let valid = this.list.find((f) => {
            let value = this.display ? f[this.display] : f;
            return value == this.inputValue;
          });
          if (!valid) {
            this.inputValue = "";
            this.$emit("changeModel", null);
            this.$emit("selected");
          }
          if (!this.isCmbClick) this.showList(false);
        }, 100);
      }
    },
    onCmbClick() {
      this.isCmbClick = true
      this.$nextTick(() => {
        if (this.type == "cmb") {
          this.showList(!this.isShowList);
          // this.$refs.input.focus();
        }
      });
    },
    onKeyDown(e) {
      // 当前行键盘事件
      if (e.keyCode == 40) {
        if (this.type == "cmb") {
          if (this.isShowList == true) {
            let index = ++this.selectedListIndex;
            if (index == this.searchList.length) index = 0;
            this.selectedListIndex = index;
          }
          if (this.editable) this.isShowList = true;
          else this.$emit("key", "ArrowDown", e.target);
        } else {
          this.$emit("key", "ArrowDown", e.target);
        }
      }
      if (e.keyCode == 38) {
        if (this.type == "cmb") {
          // 键盘向下事件 判断如果类型为cmb则显示下拉选择列表
          if (this.isShowList == true) {
            let index = --this.selectedListIndex;
            if (index < 0) index = this.searchList.length - 1;
            this.selectedListIndex = index;
          }
          if (!this.editable) this.$emit("key", "ArrowUp", e.target);
        } else {
          this.$emit("key", "ArrowUp", e.target);
        }
      }

      if (e.keyCode == 39) {
        this.$emit("key", "ArrowRight", e.target);
      }

      if (e.keyCode == 37) {
        this.$emit("key", "ArrowLeft", e.target);
      }

      if (e.keyCode == 13) {
        if (this.type == "cmb") {
          let value = this.searchList[this.selectedListIndex];
          this.$emit("changeModel", this.take ? value[this.take] : value);
          this.inputValue = this.display ? value[this.display] : value;
          this.selectedListIndex = 0;
          this.isShowList = false;
          this.$emit("selected");
        }
        this.$emit("key", "Enter", e.target);
      }
    },
    enterSelect(index) {
      // 接收子组件tableFocusList鼠标entermouse参数
      this.selectedListIndex = index;
    },
    // 切换时间
    changeTime(e) {
      this.$emit("changeModel", e);
    },
  },
  watch: {
    bindValue(value) {
      if (this.type == "cmb") {
        let item = this.list.find((f) => {
          var obj = this.take ? f[this.take] : f;
          return obj == value;
        });
        if (item) {
          this.inputValue = this.display ? item[this.display] : item;
        } else {
          this.inputValue = "";
        }
      } else if (this.type == "date") {
        this.inputValue = value;
      } else {
        this.inputValue = value;
      }
    },
    selected(value) {
      this.$emit("selectedTd", value);
    },
  },
};
</script>

<style lang="stylus">
.tableUnit{
  .el-icon-date:before {
    content: "";
  }
  .el-input__inner{
    padding:0 0 0 15px;
    border:none;
  }
  .el-date-editor.el-input{
    width:auto;
  }
}
</style>

<style lang="stylus" scoped>
.selectedUnit {
  background-color: #eee;
}

.tableUnit {
  position: relative;
  width: 100px;
  border: 1px solid #e0e0e0;

  .editable {
    background: #f5f7fa;
  }

  .el-icon-arrow-down {
    width: 6px;
    height: 10px;
  }

  .el-icon-arrow-down:before {
    display: inline-block;
    width: 6px;
    height: 10px;
    content: '';
    background: url('../../../public/img/arrow_right.png');
    transform: rotate(90deg);
    background-size: 6px 10px;
  }

  >input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // height 100%
    width: 100%;
    border: 0;
    text-align: center;
    outline: 0;
    height: 40px;
  }

  >a {
    position: absolute;
    right: 10px;
    top: -2px;
    bottom: 0;
    font-size: 21px;
    cursor: pointer;
  }

  .select-list {
    position: absolute;
    left: 0;
    right: 0;
    top: 36px;
  }
}

input:disabled {
  // background-color: rgb(245, 247, 250);
  background:#fff;
  cursor:not-allowed!important;
}
</style>
